module.exports = __webpack_public_path__ + "../resources/img/ic_re_consuming_p2.faa537ce.svg";